import { TeamTypesEnum } from 'types/generated/server';
import { VairRound } from 'screens/TournamentDetails/types';

export interface SubmitMatchesPayload {
  eventId: string;
  completedRounds: VairRound[];
  groupTitle: string;
  eventTitle: string;
  location: string;
  matchDate: string;
  teamType: TeamTypesEnum;
  // Required: the group's configured scoring (group.totalPoints / group.winBy).
  // Submitted to VAIR as the match format — never defaulted, so we don't report
  // incorrect scoring rules to VAIR for groups that don't use 11/win-by-2.
  winScore: number;
  winBy: number;
}

export const VAIR_SUBMIT_MATCHES_API = `v1/vair/submit-matches`;
